import moment from "moment-timezone";
import ClassTimeModel from "src/models/ClassTimeModel";
import { Day, Frequency } from "types/code-generator";
import { sortByDayAndTime } from "./sortByDayAndTime";

export default function shortenClassTimes(classItem: {
  classTimes?: {
    allDayPresentation: string;
    day: Day;
    date: Date;
    endTime: string;
    location: {
      id: string;
    };
    zone: {
      id: string;
    };
    startTime: string;
  }[];
  frequency: Frequency;
  instructors?: { firstName: string; lastName: string }[];
  startDate?: Date;
}) {
  const sortedClassTimes = sortByDayAndTime(classItem.classTimes || []);
  const shortenedClassTimes = {};
  const results: any[] = [];

  sortedClassTimes.forEach((ct) => {
    let slug = `${ct.startTime}:${ct.endTime}:${
      ct.location?.id ? ct.location.id : ""
    }:${ct.zone?.id ? ct.zone.id : ""}`;

    if (!ct.startTime && !ct.endTime && ct.allDayPresentation) {
      slug = ct.allDayPresentation;
    }

    if (ct.date) {
      slug += `:${moment(ct.date).format("YYYY-MM-DD")}`;
    }

    slug += `:${ct.location && ct.location.id && ct.location.id}:${
      ct.zone && ct.zone.id && ct.zone.id
    }`;

    if (shortenedClassTimes[slug]) {
      shortenedClassTimes[slug].push(ct);
    } else {
      shortenedClassTimes[slug] = [ct];
    }
  });

  Object.keys(shortenedClassTimes).forEach((k) => {
    const classTimes: ClassTimeModel[] = shortenedClassTimes[k];
    const days = classTimes.reduce((acc: string[], ct) => {
      if (ct.day && !acc.includes(ct.day)) {
        acc.push(ct.day);
      }
      return acc;
    }, []);
    const daysList = days
      .map((d) => {
        if (days.length === 1) {
          return `${d}s`;
        } else if (
          d === Day.Monday ||
          d === Day.Wednesday ||
          d === Day.Friday
        ) {
          return d.slice(0, 1);
        } else {
          return d.slice(0, 2);
        }
      })
      .join(", ");
    const startTime = classTimes[0].startTime
      ? moment(classTimes[0].startTime, "HH:mm").format("h:mm a")
      : "";
    const endTime = classTimes[0].endTime
      ? moment(classTimes[0].endTime, "HH:mm").format("h:mm a")
      : "";
    const location = classTimes[0].location && classTimes[0].location.title;
    const zone = classTimes[0].zone && classTimes[0].zone.title;

    let instructor;

    if (
      "instructors" in classItem &&
      classItem.instructors &&
      classItem.instructors.length > 0 &&
      !instructor
    ) {
      instructor = classItem.instructors
        .map((cti) => `${cti.firstName} ${cti.lastName}`)
        .join(", ");
    }

    let date = classTimes[0].date;

    if (classItem.frequency === Frequency.OneTime) {
      date = classItem.startDate;
    }

    results.push({
      days: daysList,
      date,
      allDayPresentation:
        !classTimes[0].startTime &&
        !classTimes[0].endTime &&
        classTimes[0].allDayPresentation,
      startTime,
      endTime,
      location,
      zone,
      instructor,
      atAccountHome: classTimes[0].atAccountHome,
    });
  });

  return results;
}
